<template>
  <b-modal id="enter-code-modal" ref="modal" hide-footer hide-header centered>
    <div class="header">
      <span class="close-icon" @click="closeModal">
        <img src="@/assets/svg/close.svg" aria-label="close" />
      </span>

      <h3>Введите код</h3>

      <h5>Введите код из под крышки</h5>
    </div>

    <form ref="form" class="modal-form" @submit.stop.prevent="submit">
      <b-form-group label-for="code-input" :invalid-feedback="invalidCode">
        <b-form-input
          id="code-input"
          placeholder="Код"
          v-model="$v.item.code.$model"
          :class="{
            'is-invalid': $v.item.code.$error,
            'is-valid': !$v.item.code.$invalid && $v.item.code.$dirty,
          }"
          :state="validateState($v.item.code)"
          required
        />
      </b-form-group>
    </form>

    <b-button
      class="button button-green button-green-bg"
      type="submit"
      :disabled="disabledBtn || submittedBtn"
      @click="submit"
      onclick="ym(108239013,'reachGoal', 'send_cod')"
    >
      Отправить
    </b-button>
  </b-modal>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { helpers, required } from "vuelidate/lib/validators";

const codeValidator = helpers.regex(
  "codeValidator",
  /^(?=.*[A-Za-z])[A-Za-z\d]{4,8}$/,
);

export default {
  mixins: [validationMixin],

  validations: {
    item: {
      code: {
        required,
        codeValidator,
      },
    },
  },

  data() {
    return {
      item: {
        code: "",
      },
      submittedBtn: false,
    };
  },

  computed: {
    invalidCode() {
      const code = this.$v.item.code;

      if (!code.$dirty) return "";

      if (!code.required) return "Обязательное поле";
      if (!code.codeValidator)
        return "Код: 4–8 символов, минимум 1 буква (латиница)";

      return "";
    },

    disabledBtn() {
      return this.$v.item.$anyError;
    },
  },

  methods: {
    onInput() {
      this.item.code = this.item.code
        .replace(/[^A-Za-z0-9]/g, "")
        .toUpperCase();
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    resetModal() {
      this.$v.$reset();

      this.item.code = "";
      this.submittedBtn = false;

      this.$bvModal.hide("enter-code-modal");

      this.$emit("getThanksText", "");
      this.$emit("getThanksTitle", "Код отправлен на проверку");

      this.$bvModal.show("thanks-modal");
    },

    closeModal() {
      this.$v.$reset();

      this.item.code = "";
      this.submittedBtn = false;

      this.$bvModal.hide("enter-code-modal");
    },

    submit() {
      this.submittedBtn = true;

      this.$v.item.$touch();

      if (this.$v.item.$anyError) return;

      axios
        .post(
          "codes",
          {
            code: this.item.code,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token-bockarev"),
            },
          },
        )
        .then(() => {
          this.resetModal();
        })
        .catch((error) => {
          if (error.response?.data?.message) {
            this.$emit("getErrorText", error.response.data.message);
            this.$bvModal.show("error-modal");
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  margin-top: 30px;
  width: 100%;
  border: 1px solid $black !important;

  &:hover {
    opacity: 0.8 !important;
  }

  @media (max-width: 576px) {
    margin-top: 15px;
  }
}

.header {
  margin-bottom: 28px;
}

.modal-form {
  padding: 0px !important;
}

h5 {
  color: white;
  margin-top: 10px;
  font-family: $regular;
  font-size: 18px;
  line-height: 116%;

  @media (max-width: 576px) {
    font-size: 14px;
  }
}
</style>
